import * as R from 'ramda';

const attachPaginationQueryInfo = ({ page, pageSize, page_no, page_size }) => R.pipe(
  R.assocPath(['options', 'pagination', 'currentPage'], page !== undefined ? page - 1 : page_no - 1),
  R.assocPath(['options', 'pagination', 'pageSize'], pageSize !== undefined ? pageSize : page_size),
);

export { attachPaginationQueryInfo };
export default { attachPaginationQueryInfo };
